module.exports = __webpack_public_path__ + "img/bm.6f1a8eee.png";